import { gql } from '@apollo/client';

export const GET_PRO_SUBSCRIPTION_PLANS = gql`
    query getPro($proId: ID!) {
        getPro(proId: $proId) {
            _id
            userSubscriptionPlans {
                _id
                status
                type
                startDate
                endDate
                commitmentStartDate
                commitmentEndDate
                cancelDate
                canceledDate
                cancelAtEndPeriod
                stripeId
                durationInterval
                durationIntervalCount
                name
                description
                price {
                    unitAmount
                    currency
                    recurring
                    metadata {
                        partnerName
                    }
                }
            }
        }
    }
`;

export const GET_USER_SUBSCRIPTION_PLANS_UPERCUT = gql`
    query getUserSubscriptionPlansUpercut($query: String, $filter: UserSubscriptionPlansFilter, $pagination: Pagination) {
        getUserSubscriptionPlansUpercut(query: $query, filter: $filter, pagination: $pagination) {
            docs {
                _id
                proId
                pro {
                    _id
                    commercialName
                    email
                    brandLogo {
                        url
                    }
                }
                status
                type
                startDate
                endDate
                commitmentStartDate
                commitmentEndDate
                durationInterval
                durationIntervalCount
                name
                description
                stripeId
                createdAt
                price {
                    unitAmount
                    currency
                    recurring
                    metadata {
                        partnerName
                    }
                }
            }
            meta {
                totalDocs
                limit
                page
                totalPages
                nextPage
                prevPage
            }
        }
    }
`;

export const GET_USER_SUBSCRIPTION_PLANS_FILTER_DATASET_UPERCUT = gql`
    query getUserSubscriptionPlansFilterDatasetUpercut($query: String, $filter: UserSubscriptionPlansFilter) {
        getUserSubscriptionPlansFilterDatasetUpercut(query: $query, filter: $filter) {
            statuses
            partnerNames
        }
    }
`;

export const GET_FEATURES_UPERCUT = gql`
    query getFeaturesUpercut($filter: FeatureFilter) {
        getFeaturesUpercut(filter: $filter) {
            _id
            key
            name
            description
            order
            configuration {
                duration
                unit
                enabled
                maximum
                used
                type
                limit
            }
        }
    }
`;

export const UPDATE_FEATURE_UPERCUT = gql`
    mutation updateFeatureUpercut($_id: ID, $key: String, $proId: ID, $payload: FeatureInput!, $reason: String) {
        updateFeatureUpercut(_id: $_id, key: $key, proId: $proId, payload: $payload, reason: $reason) {
            _id
            key
            name
            configuration {
                duration
                unit
                enabled
                maximum
                used
                type
                limit
            }
        }
    }
`;

export const GET_FEATURE_CHANGE_LOGS = gql`
    query getFeatureChangeLogsUpercut($featureIds: [ID!]!, $page: Int, $limit: Int) {
        getFeatureChangeLogsUpercut(featureIds: $featureIds, page: $page, limit: $limit) {
            docs {
                _id
                featureId
                reason
                configurationBefore
                configurationAfter
                createdBy
                createdByUser {
                    _id
                    firstname
                    lastname
                    email
                }
                createdAt
                feature {
                    _id
                    key
                    name
                }
            }
            meta {
                totalDocs
                limit
                page
                totalPages
                hasNextPage
                hasPrevPage
            }
        }
    }
`;
